import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "_relative" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Empty = _resolveComponent("Empty")!
  const _component_Column = _resolveComponent("Column")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Paginator = _resolveComponent("Paginator")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      ($setup.state.isLoading)
        ? (_openBlock(), _createBlock(_component_Loader, {
            key: 0,
            isOverlay: ""
          }))
        : _createCommentVNode("", true),
      _createElementVNode("h2", {
        class: _normalizeClass(_ctx.$style.header)
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style.headerButtons)
        }, [
          _createVNode(_component_Datepicker, {
            class: _normalizeClass(_ctx.$style.datePicker),
            modelValue: $setup.dateRange,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => (($setup.dateRange) = $event)),
              $setup.onDatesChanged
            ],
            range: "",
            enableTimePicker: false
          }, null, 8, ["class", "modelValue", "onUpdate:modelValue"]),
          _createVNode(_component_Button, {
            disabled: $setup.state.isDownloading,
            class: _normalizeClass([_ctx.$style.exportButton, "p-button p-component"]),
            onClick: $setup.exportTransactions
          }, {
            default: _withCtx(() => [
              (!$setup.state.isDownloading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t('settings_page.export.export')), 1))
                : _createCommentVNode("", true),
              ($setup.state.isDownloading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('settings_page.export.exporting')), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["disabled", "class", "onClick"])
        ], 2)
      ], 2),
      _createVNode(_component_DataTable, {
        value: $setup.state.data.transactions,
        loading: $setup.state.isLoading,
        responsiveLayout: "scroll"
      }, {
        empty: _withCtx(() => [
          _createVNode(_component_Empty)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, { header: "id" }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.id), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            header: _ctx.$t('transactions_page.type')
          }, {
            body: _withCtx((slotProps) => [
              (slotProps.data.type == 'income')
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(_ctx.$style.green)
                  }, _toDisplayString(slotProps.data.type), 3))
                : _createCommentVNode("", true),
              (slotProps.data.type == 'expense')
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: _normalizeClass(_ctx.$style.red)
                  }, _toDisplayString(slotProps.data.type), 3))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            header: _ctx.$t('transactions_page.amount')
          }, {
            body: _withCtx((slotProps) => [
              (slotProps.data.type == 'income')
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, " +" + _toDisplayString(slotProps.data.amount), 1))
                : _createCommentVNode("", true),
              (slotProps.data.type == 'expense')
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, " -" + _toDisplayString(slotProps.data.amount), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            header: _ctx.$t('transactions_page.time')
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString($setup.dateformat(new Date(slotProps.data.created_at * 1000), 'dd.mm.yyyy')), 1)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            header: _ctx.$t('transactions_page.vehicle')
          }, {
            body: _withCtx((slotProps) => [
              (slotProps.data.car)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    class: "_link",
                    to: { name: 'Vehicle', params: { id: slotProps.data.car.id } }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(slotProps.data.car.vin), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["header"])
        ]),
        _: 1
      }, 8, ["value", "loading"])
    ]),
    _createVNode(_component_Paginator, {
      currentPage: $setup.state.meta.current_page || _ctx.$route.query.page || 1,
      total: $setup.state.meta.total,
      lastPage: $setup.state.meta.last_page,
      perPage: $setup.state.meta.perPage,
      count: $setup.state.meta.to
    }, null, 8, ["currentPage", "total", "lastPage", "perPage", "count"])
  ], 64))
}